import { Users, CalendarCheck, Star, XCircle } from 'lucide-react';
import clsx from 'clsx';

interface ShiftOverviewCardProps {
  totalStaff: number;
  requiredStaff: number;
  reservationCount: number;
  vipCount: number;
  eightySixCount: number;
}

export default function ShiftOverviewCard({
  totalStaff,
  requiredStaff,
  reservationCount,
  vipCount,
  eightySixCount,
}: ShiftOverviewCardProps) {
  const isFullyStaffed = totalStaff >= requiredStaff;

  const stats = [
    {
      label: 'Staff',
      value: `${totalStaff}/${requiredStaff}`,
      icon: Users,
      color: isFullyStaffed ? 'emerald' : 'amber',
      bgClass: isFullyStaffed ? 'bg-emerald-50' : 'bg-amber-50',
      iconClass: isFullyStaffed ? 'text-emerald-500' : 'text-amber-500',
      valueClass: isFullyStaffed ? 'text-emerald-700' : 'text-amber-700',
    },
    {
      label: 'Reservations',
      value: reservationCount.toString(),
      icon: CalendarCheck,
      color: 'blue',
      bgClass: 'bg-blue-50',
      iconClass: 'text-blue-500',
      valueClass: 'text-blue-700',
    },
    {
      label: 'VIPs',
      value: vipCount.toString(),
      icon: Star,
      color: 'purple',
      bgClass: vipCount > 0 ? 'bg-purple-50' : 'bg-slate-50',
      iconClass: vipCount > 0 ? 'text-purple-500' : 'text-slate-400',
      valueClass: vipCount > 0 ? 'text-purple-700' : 'text-slate-500',
    },
    {
      label: "86'd",
      value: eightySixCount.toString(),
      icon: XCircle,
      color: 'red',
      bgClass: eightySixCount > 0 ? 'bg-red-50' : 'bg-slate-50',
      iconClass: eightySixCount > 0 ? 'text-red-500' : 'text-slate-400',
      valueClass: eightySixCount > 0 ? 'text-red-700' : 'text-slate-500',
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <h3 className="text-sm font-semibold text-slate-900 uppercase tracking-wide mb-3">
        Overview
      </h3>
      <div className="grid grid-cols-2 gap-3">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className={clsx('rounded-lg p-3', stat.bgClass)}
          >
            <div className="flex items-center gap-2 mb-1">
              <stat.icon className={clsx('w-4 h-4', stat.iconClass)} />
              <span className="text-xs font-medium text-slate-500 uppercase">
                {stat.label}
              </span>
            </div>
            <p className={clsx('text-2xl font-bold', stat.valueClass)}>
              {stat.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
